import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const CustomToolbar = ({ label, onNavigate, onView, view }) => {
  const { t } = useTranslation("global");

  return (
    <Row className="align-items-center mb-3">
      <Col xs="6">
        <h5 className="mb-0">{label}</h5>
      </Col>
      <Col xs="6" className="text-end">
        <Button
          variant={view === "month" ? "primary" : "outline-primary"}
          className={`btn-nxt-pre me-2 ${view === "month" ? "active-view" : ""}`}
          onClick={() => onView("month")}
        >
          {t("calendar.month")}
        </Button>
        <Button
          variant={view === "week" ? "primary" : "outline-primary"}
          className={`btn-nxt-pre me-2 ${view === "week" ? "active-view" : ""}`}
          onClick={() => onView("week")}
        >
          {t("calendar.week")}
        </Button>
        <Button className="btn-nxt-pre me-2" onClick={() => onNavigate("PREV")}>
          {t("calendar.prev")}
        </Button>
        <Button className="btn-nxt-pre" onClick={() => onNavigate("NEXT")}>
          {t("calendar.next")}
        </Button>
      </Col>
    </Row>
  );
};

export default CustomToolbar;